/**
 * plugins/index.js
 *
 * Automatically included in `./src/main.js`
 */

// Plugins
import vuetify from './vuetify'
import pinia from '../stores'
import router from '../router'
import { bus_setup } from '../utils/event_bus'
import pdfjs from '@/utils/pdfjs_loader'
import VueQrcode from '@chenfengyuan/vue-qrcode'
import VueApexCharts from 'vue3-apexcharts'
import PictureView from "/src/components/renderers/PictureView.vue"
import ButtonQRShow from "/src/components/renderers/ButtonQRShow.vue";
import { deep_links, hide_status_bar } from "./capacitor";

// Chart numbers in the same monospace face as the rest of the app's numbers
// (`.pit-mono`). ApexCharts merges `window.Apex` into every chart, so this has
// to be set before the first chart mounts. Two things to know when a chart
// puts *names* on an axis instead of numbers:
// - the global `yaxis` object overrides a chart's own `yaxis` object, so a
//   horizontal bar chart (names on the y axis) opts out by passing `yaxis` as
//   an array, which ApexCharts leaves unmerged;
// - a chart's own `xaxis.labels.style.fontFamily` does win over this one.
const MONO_FONT = "Roboto Mono, monospace"
window.Apex = {
  ...(window.Apex || {}),
  xaxis: { labels: { style: { fontFamily: MONO_FONT } } },
  yaxis: { labels: { style: { fontFamily: MONO_FONT } } },
  dataLabels: { style: { fontFamily: MONO_FONT } },
}

export function registerPlugins(app) {

  // Plugins
  // Pinia before the router: installing the router runs the first navigation,
  // and a route that reads a store on the way (the `/qr` redirect) failed when
  // the page was opened straight at that address.
  app
    .use(vuetify)
    .use(pinia)
    .use(router)
    .use(bus_setup)
    .use(pdfjs)
    .use(VueApexCharts)

  // Components
  app.component(VueQrcode.name, VueQrcode)
  app.component("PictureView", PictureView)
  app.component("ButtonQRShow", ButtonQRShow)

  // Capacitor deeplinks
  deep_links(router)

  // Hide status bar
  hide_status_bar()
}
